import { appConstants } from "constants/appConstants";
import useHomeFacilities from "hooks/useHomeFacilities";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "store";

export default function HomeEquipments({ venue }: any) {
  const { t } = useTranslation();

  const { facilites } = useHomeFacilities();

  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{t("amenities")}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{t("amenities_desc")}</span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      {/* 6 */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
        {facilites.map((item: any, index: number) => (
          <FacilityItem item={item} key={index} />
        ))}
      </div>
    </div>
  );
}

const FacilityItem = ({ item }: any) => {
  const { language } = useSelector((state: RootState) => state.lang);

  return (
    <div key={item?.facility_logo} className="flex items-center space-x-3">
      <i className={`text-3xl las ${item?.facility_logo}`}></i>
      <span className=" ">
        {item?.is_use_quality ? item?.quality + " x " : ""}
        {language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? item?.facility_name_tc : item?.facility_name_en}
      </span>
    </div>
  );
};
